// src/pages/Catalog.js
import React from "react";
import DOCS from "../data/docs.json";

export default function Catalog() {
    return (
        <section className="section">
            <div className="container">
                <header className="section-head">
                    <h1 className="page-title">Katalog / Dokümanlar</h1>
                    <p className="page-subtitle">Görsel önizleme + tek tıkla indir.</p>
                </header>

                <div className="catalog-grid">
                    {DOCS.map((d) => (
                        <article key={d.id} className="doc-card">
                            <div className="doc-media">
                                <img
                                    src={d.img}
                                    alt={`${d.title} kapak görseli`}
                                    loading="lazy"
                                    decoding="async"
                                    width="300" height="300"
                                    sizes="(max-width: 680px) 90vw, (max-width: 980px) 45vw, 380px"
                                />
                                <div className="doc-badges">
                                    <span className="badge">{d.format}</span>
                                    <span className="badge">{d.size}</span>
                                </div>
                            </div>
                            <div className="doc-body">
                                <h3 className="doc-title">{d.title}</h3>
                                <p className="doc-desc">{d.desc}</p>
                                <div className="doc-actions">
                                    <a className="btn primary" href={d.url} download>İndir</a>
                                    <a className="btn ghost" href={d.url} target="_blank" rel="noreferrer">Yeni Sekmede Aç</a>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="cta" style={{ marginTop: 24 }}>
                    <h3>Özel teklif dosyası ister misiniz?</h3>
                    <p>Projenize özel PDF hazırlayalım.</p>
                    <a className="btn primary" href="/contact#form">İletişime Geç</a>
                </div>
            </div>
        </section>
    );
}